export default __webpack_public_path__ + "static/media/C0005.ec202165.png";